import { render, staticRenderFns } from "./LectureLessonInfoVideo.vue?vue&type=template&id=2e2b2925&"
import script from "./LectureLessonInfoVideo.vue?vue&type=script&lang=js&"
export * from "./LectureLessonInfoVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports